module.exports = __webpack_public_path__ + "media/icons/quote-617ef2b5.svg";